import type { Route } from "./+types/$locale.terms";
import { buildSeoMeta } from "@/components/seo/meta";

export { TermsPage as default } from "@/features/legal/routes/TermsPage";

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Terms & Conditions",
        description:
            "Terms and Conditions for Stork Rentals baby equipment rental service.",
        path: "/terms",
        locale,
        availableLocales: [{ code: "en" }],
    });
}
